import type { BaseContentProps } from "./types"

export const ImageContent = ({ content }: BaseContentProps) => {
  if (!content.media) {
    return null
  }

  return (
    <div
      style={{
        width: "100%",
        paddingInline: 24,
        position: "relative",
      }}
    >
      <img
        key={content.media.url}
        src={content.media.url}
        style={{
          width: "100%",
          height: 220,
          minHeight: 220,
          objectFit: "cover",
          objectPosition: "center",
          backgroundColor: "rgba(255, 255, 255, 0.15)",
          borderRadius: 16,
          overflow: "hidden",
          display: "block",
        }}
        alt=""
      />
    </div>
  )
}
